"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.getChartOptions = void 0;
function makeLine(data, color, zIndex, dashStyle) {
    if (dashStyle === void 0) { dashStyle = 'solid'; }
    return {
        id: '',
        enableMouseTracking: false,
        showInLegend: false,
        type: 'line',
        color: color,
        dashStyle: dashStyle,
        zIndex: zIndex,
        marker: {
            enabled: false
        },
        linkedTo: ':previous',
        data: data
    };
}
function processDrillDownSeries(series) {
    return __assign(__assign({}, series), { type: 'line', marker: {
            enabled: true,
            radius: 5,
            symbol: 'circle'
        }, data: series.data });
}
function generateSeries(dataRows, legends, zindex) {
    if (zindex === void 0) { zindex = 6; }
    var series = [];
    var _loop_1 = function (legend) {
        var tagKey = legend['tag'];
        var tagColor = legend['color'];
        var seriesData = dataRows.filter(function (item) {
            return item.colorTag === tagKey && typeof item.y !== 'undefined';
        });
        if (seriesData.length > 0) {
            series.push({
                'name': tagKey,
                'color': tagColor,
                'zIndex': zindex,
                'data': seriesData
            });
        }
    };
    for (var _i = 0, legends_1 = legends; _i < legends_1.length; _i++) {
        var legend = legends_1[_i];
        _loop_1(legend);
    }
    return series;
}
function getChartOptions(graph, options) {
    var currentNode = options.currentNode, chartTitle = options.chartTitle, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp;
    var nodeName = currentNode.name;
    var mainSeriesData = graph.mainRows;
    var siblingSeriesData = (graph.siblingRows || []);
    var series = generateSeries(mainSeriesData, legends, 6);
    var drillDown = graph.mainDrillDown.map(function (drillDownSeries) {
        return processDrillDownSeries(drillDownSeries);
    });
    var mainLinesData = mainSeriesData.filter(function (item) {
        return item.onCurve === true || item.onCurve === 'true' || item.onCurve === "true";
    });
    if (mainLinesData.length > 1) {
        var mainLines = makeLine(mainLinesData.map(function (row) { return [row.x, row.y]; }), '#8bb3e0', 4);
        series = series.concat(mainLines);
        var mainEfcData = mainLinesData.filter(function (item) { return item.isEF; }).map(function (row) { return [row.x, row.y]; });
        var mainEfcLines = makeLine(mainEfcData, '#8bb3e0', 3, 'longdash');
        series = series.concat(mainEfcLines);
    }
    if (siblingSeriesData.length > 0) {
        var siblingSeries = generateSeries(siblingSeriesData, siblingLegends, 5);
        series = series.concat(siblingSeries);
        var siblingLinesData = siblingSeriesData.filter(function (item) {
            return item.onCurve === true || item.onCurve === 'true' || item.onCurve === "true";
        });
        if (siblingLinesData.length > 1) {
            var siblingLines = makeLine(siblingLinesData.map(function (row) { return [row.x, row.y]; }), '#e8c7b2', 3);
            series = series.concat(siblingLines);
            // let siblingEfcData = generateEfcData(siblingLinesData.map(row => [row.x, row.y]));
            var siblingEfcData = siblingLinesData.filter(function (item) { return item.isEF; }).map(function (row) { return [row.x, row.y]; });
            var siblingEfcLines = makeLine(siblingEfcData, '#e8c7b2', 3, 'longdash');
            series = series.concat(siblingEfcLines);
        }
        drillDown = drillDown.concat(graph.siblingDrillDown.map(function (drillDownSeries) {
            return processDrillDownSeries(drillDownSeries);
        }));
    }
    return {
        chart: {
            renderTo: 'chartContainer',
            height: 560,
            width: 580,
            type: 'scatter',
            zoomType: 'xy',
            marginRight: 50
        },
        credits: {
            text: timestamp,
            href: null
        },
        title: {
            text: chartTitle
        },
        tooltip: {
            enabled: settings.showTooltip,
            formatter: function () {
                if (this.point.name) {
                    return "<b>" + this.point.name + "</b> <i>(" + this.series.name + ")</i><br />" +
                        (graph.yTitle + ": <b>" + this.point.y.toFixed(settings.decimals) + "</b><br />") +
                        (graph.xTitle + ": <b>" + this.point.x.toFixed(settings.decimals) + "</b>");
                }
                else {
                    return false;
                }
            },
            crosshairs: [true, true]
        },
        xAxis: {
            title: {
                enabled: true,
                text: graph.xTitle
            },
            startOnTick: true,
            endOnTick: true,
            showLastLabel: true,
            plotLines: [{
                    value: 0,
                    color: 'black',
                    width: 2,
                    zIndex: 1
                }]
        },
        yAxis: {
            title: {
                enabled: true,
                text: graph.yTitle
            },
            plotLines: [{
                    value: 0,
                    color: 'black',
                    width: 2,
                    zIndex: 1
                }]
        },
        plotOptions: {
            series: {
                turboThreshold: 0
            },
            scatter: {
                dataLabels: {
                    enabled: settings.showLabel,
                    style: {
                        fontWeight: 'thin'
                    },
                    formatter: function () {
                        if (!this.series.name || this.series.name.indexOf(":") !== -1) {
                            this.series.name = nodeName;
                        }
                        return this.point.name.slice(0, settings.charsInLabel);
                    }
                },
                marker: {
                    radius: 5,
                    symbol: 'circle',
                    states: {
                        hover: {
                            enabled: true,
                            lineColor: 'rgb(100,100,100)'
                        }
                    }
                },
                states: {
                    hover: {
                        marker: {
                            enabled: false
                        }
                    }
                }
            }
        },
        series: series,
        drilldown: {
            activeAxisLabelStyle: {
                textDecoration: 'none',
                cursor: 'default',
                color: '#666666',
                'font-weight': 'normal',
                'pointer-events': 'none'
            },
            series: drillDown
        }
    };
}
exports.getChartOptions = getChartOptions;
//# sourceMappingURL=efficient-frontier.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/efficient-frontier/efficient-frontier.chart.js